import React, {useEffect, useRef, useState} from 'react';
import s from './styles.module.css'
import Header from "./0-header";
import Commands from "./1-commands";
import Table from "./2-table";
import {useStore} from "../../hooks/useStore";
import SockJS from 'sockjs-client';
import Stomp from 'stompjs';
import {toast} from "react-toastify";
import {Button, DialogContent} from "@mui/material";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import classNames from "classnames";
import SettingsDistiplines from "../setting_distiplines";
import SettingsSorev from "../settings_sorev";
import {observer} from "mobx-react-lite";
import FigureBox from "./figure_box";
import Report from "../report";
import {BASE_API_URL, SOCKET_API_URL} from "../../constants";
import AlertDialogCustomButton from "../../components/dialog_modal/custom_button"
import api from "../../api/api";
import JudgeSettings from "../judge_settings";
import TimerReceiver from "./timers/TimerReceiver";
import ReplicationDot from "../../components/replication/ReplicationDot";

const headers = [
    {id: 1, title: 'Хронометраж'},
    {id: 2, title: 'Настройка дисциплин'},
    {id: 3, title: 'Настройка соревнования'},
    {id: 5, title: 'Настройки'},
    {id: 4, title: 'Отчеты'},

]
const Judging = observer(() => {
    const store = useStore()

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const role = localStorage.getItem("role");
    const isReferee = (role === 'referee' || role === 'announcer');

    const catMenu = useRef(null)

    const [showMenu, setShowMenu] = useState(false)
    const [headerSelect, setHeaderSelect] = useState(1)
    const [statusInfo, setStatusInfo] = useState()
    const [selectedCommand, setSelectedCommand] = useState(null)
    const [select, setSelect] = useState(null);
    const [showMoreCommand, setShowMoreCommand] = useState(false)
    const [ageGroupDisciplines, setAgeGroupDisciplines] = useState([])
    const [commands, setCommands] = useState([])
    const [scoreCommand, setScoreCommand] = useState(null)
    const [judgleStatus, setJudgleStatus] = useState(null)
    const [socketData, setSocketData] = useState(null)
    const [version, setVersion] = useState(null);
    const [versionColor, setVersionColor] = useState(null);
    const [ids, setIds] = useState({
        id_group: null, id_disciplin: null, discipline_stage_id: null
    })
    const [openDialogCustom, setOpenDialogCustom] = React.useState(false);
    const [coachTypeId, setCoachTypeId] = React.useState(0);
    const [coachTypeNumber, setCoachTypeNumber] = React.useState(0);
    const stompClientRef = useRef(null);
    const socketRef = useRef(null);
    const reconnectTimeoutRef = useRef(null);
    const isInitialConnect = useRef(true);
    const [isTimerVisible, setIsTimerVisible] = React.useState(false);
    const selectedCommandObject = commands?.find((f) => f.competition_application_discipline_id === selectedCommand) || {}
    const [portalChanges, setPortalChanges] = useState({});

    // Инициализация состояния для трёх тренеров
    const [timers, setTimers] = useState(getDefaultTimers);
    const [shouldScroll, setShouldScroll] = useState(false);
    const [saveButton, setSaveButton] = useState(false);

    const movingStatusNextOrPrev = async (type) => {
        await store.judging.movingStatusNextOrPrev(type)
        await store.judging.getAllCommand(ids?.id_group, ids?.id_disciplin, ids?.discipline_stage_id)
        setCommands(store.judging.commands)
        setStatusInfo(JSON.parse(JSON.stringify(store.judging.status)))
        setShouldScroll(true);
    }

    const getJudgleStatus = async () => {
        await store.judging.getJudgleStatus()
        setJudgleStatus(JSON.parse(JSON.stringify(store.judging.judgleStatus)))
    }

    const choiceJudge = async () => {
        await api().get(`device_choice/${coachTypeId}/${coachTypeNumber}`).then((res) => {
            if (res?.data?.status === 'ok') {
                toast.success('Выбор судьи на устройстве')
            }
            if (res?.data?.status === 'error') {
                toast.error(res?.data?.msg)
                setOpenDialogCustom(false)
            }
        })
        setOpenDialogCustom(false)

        await getJudgleStatus()
    }

    const resetJudgeSession = async () => {

        await api().get(`device_kill_session/${coachTypeId}/${coachTypeNumber}`).then((res) => {
            if (res?.data?.status === 'ok') {
                toast.success('Сброс устройства')
            }
            if (res?.data?.status === 'error') {
                toast.error(res?.data?.msg)
                setOpenDialogCustom(false)
            }
        })
        setOpenDialogCustom(false)

        await getJudgleStatus()
    }

    const startJudging = async () => {
        const currentGroupDiscipline = ageGroupDisciplines.find((f) => f.id === select)
        // console.log(ids)
        await store.judging.startJudging(ids?.id_group, ids?.id_disciplin, ids?.discipline_stage_id)
        await store.judging.getAllCommand(ids?.id_group, ids?.id_disciplin, ids?.discipline_stage_id)
        setCommands(store.judging.commands)
        setStatusInfo(JSON.parse(JSON.stringify(store.judging.status)))

        let send = "update_discipline_ageGroup-" + ids?.id_group + "_discipline-" +
            ids?.id_disciplin + "_disciplineStage-" + ids?.discipline_stage_id;
        await store.judging.sendSocket("method", send);
        localStorage.setItem("updateDisciplineChron", send);
    }

    const stopJudging = async () => {
        await store.judging.stopJudging()
        await store.judging.getAllCommand(ids?.id_group, ids?.id_disciplin, ids?.discipline_stage_id)
        setCommands(store.judging.commands)
        setStatusInfo(JSON.parse(JSON.stringify(store.judging.status)))
    }

    const getAllCommand = async (id_group, id_disciplin, idDisciplineStage) => {
        setIds({id_group, id_disciplin, discipline_stage_id: idDisciplineStage})
        setSelectedCommand(null)
        await store.judging.getAllCommand(id_group, id_disciplin, idDisciplineStage)
        setCommands(store.judging.commands)
    }

    const getScoreCommand = async (id) => {
        await store.judging.getScoreCommand(id)
        setScoreCommand(store.judging.scoreCommand)
    }

    function getDefaultTimers() {
        return {
            '1': {
                entry: 0.0,
                deck: 0.0,
                routine: 0.0,
                isEntryRunning: false,
                isDeckRunning: false,
                isRoutineRunning: false,
                wasEntryStarted: false,
                wasDeckStarted: false,
                wasRoutineStarted: false,
                isEntryOut: false,
                isDeckOut: false,
                isRoutineOut: false
            },
            '2': {
                entry: 0.0,
                deck: 0.0,
                routine: 0.0,
                isEntryRunning: false,
                isDeckRunning: false,
                isRoutineRunning: false,
                wasEntryStarted: false,
                wasDeckStarted: false,
                wasRoutineStarted: false,
                isEntryOut: false,
                isDeckOut: false,
                isRoutineOut: false
            },
            '3': {
                entry: 0.0,
                deck: 0.0,
                routine: 0.0,
                isEntryRunning: false,
                isDeckRunning: false,
                isRoutineRunning: false,
                wasEntryStarted: false,
                wasDeckStarted: false,
                wasRoutineStarted: false,
                isEntryOut: false,
                isDeckOut: false,
                isRoutineOut: false
            }
        }
    }

    const setClearScore = async (showUpdate = true) => {
        await store.judging.setClearScore(selectedCommand, showUpdate);
        setScoreCommand(store.judging.scoreCommand)
        setTimers(getDefaultTimers);
    }

    const setNewScore = async (id, value, showUpdate = true) => {
        await store.judging.setNewScore(selectedCommand, id, value, showUpdate, selectedCommand)
        setScoreCommand(store.judging.scoreCommand)
    }

    const setNewListScore = async (listScore, setListScore, showUpdate = true) => {
        setSaveButton(true)
        await store.judging.setNewListScore(selectedCommand, listScore, showUpdate, selectedCommand).then(() => {
            setListScore([])
        })
        setScoreCommand(store.judging.scoreCommand)
        setSaveButton(false);
    }

    const doubleStartJudging = async (id) => {
        await store.judging.doubleStartJudging(id)
        await store.judging.getAllCommand(ids?.id_group, ids?.id_disciplin, ids?.discipline_stage_id)
        setCommands(store.judging.commands)
        setStatusInfo(JSON.parse(JSON.stringify(store.judging.status)))
    }

    useEffect(() => {
        const getJudgleStatus = async () => {
            await store.judging.getJudgleStatus()
            setJudgleStatus(JSON.parse(JSON.stringify(store.judging.judgleStatus)))
        }
        getJudgleStatus();
    }, [])

    useEffect(() => {
        setIsTimerVisible(store.global.isShowTimers)
    }, [store.global.isShowTimers]);

    useEffect(() => {
        const distiplins = ageGroupDisciplines.find((f) => f.id === select)

        if (statusInfo?.competition_application_discipline_id && (distiplins?.discipline_id === statusInfo?.discipline_id && distiplins?.age_group_id === statusInfo?.age_group_id)) {
            getScoreCommand(statusInfo?.competition_application_discipline_id)
            setSelectedCommand(statusInfo?.competition_application_discipline_id)
        }
    }, [statusInfo, select])

    useEffect(() => {
        const getStatusJudging = async () => {
            await store.judging.statusJudging()
            setStatusInfo(JSON.parse(JSON.stringify(store.judging.status)))
        }

        getStatusJudging()
    }, [])

    useEffect(() => {
        const getAgeGroupDiscipline = async () => {
            await store.judging.getAgeGroupDiscipline()
            setAgeGroupDisciplines(store.judging.age_group_disciplines)
            // console.log(JSON.parse(JSON.stringify(store.judging.age_group_disciplines)))
        }
        getAgeGroupDiscipline()
    }, [])

    useEffect(() => {

        const getServerVersion = async () => {
            const res = await api().get("/get-server-version");
            setVersion(res?.data?.status);
            setVersionColor(res?.data.msg);
        }

        const connect = () => {
            socketRef.current = new SockJS(`${SOCKET_API_URL}/socket`, null, {
                transports: ['websocket', 'xhr-streaming', 'xhr-polling']
            });
            stompClientRef.current = Stomp.over(socketRef.current);
            stompClientRef.current.debug = null;
            stompClientRef.current.heartbeat.outgoing = 1000;
            stompClientRef.current.heartbeat.incoming = 1000;

            socketRef.current.onopen = () => {
                if (isInitialConnect.current) {
                    isInitialConnect.current = false;
                } else {
                    if (store.global.isShowSocketTurn) {
                        toast.success('Соединение с сервером восстановлено');
                    }
                }

                if (reconnectTimeoutRef.current) {
                    clearTimeout(reconnectTimeoutRef.current);
                    reconnectTimeoutRef.current = null;
                }
            };

            socketRef.current.onclose = () => {
                if (store.global.isShowSocketTurn) {
                    toast.error('Соединение с сервером разорвано');
                }
                attemptReconnect();
            };

            socketRef.current.onerror = (error) => {
                console.error('WebSocket ошибка:', error);
            };

            stompClientRef.current.connect({}, function (frame) {

                if (isInitialConnect.current) {
                    isInitialConnect.current = false;
                } else {
                    if (store.global.isShowSocketTurn) {
                        toast.dismiss();
                        toast.success('Соединение с сервером восстановлено');
                    }
                }

                getServerVersion().then(r => {
                });

                if (reconnectTimeoutRef.current) {
                    clearTimeout(reconnectTimeoutRef.current);
                    reconnectTimeoutRef.current = null;
                }

                stompClientRef.current.subscribe('/topic/events', async function (greeting) {
                    const res = JSON.parse(greeting.body);
                    if (res.method === 'update_device') {
                        toast.warning(res.msg, {
                            position: "bottom-left",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored",
                        });
                        const getJudgleStatus = async () => {
                            await store.judging.getJudgleStatus()
                            setJudgleStatus(JSON.parse(JSON.stringify(store.judging.judgleStatus)))
                        }
                        getJudgleStatus()
                    }

                    if (res.method === 'hand') {
                        setSocketData(res)
                    }
                    if (res.method === 'update_scores') {
                        setSocketData(res)
                    }
                    if (res.method === 'update') {
                        setSocketData(res)
                    }
                    if (res.method === 'update_user_figure') {
                        setSocketData(res)
                    }
                    if (res.method === 'switch') {
                        setSocketData(res)
                    }
                    if (res.method.startsWith("update_discipline")) {
                        setSocketData(res);
                    }
                    if (res.method === "stc-temp") {
                        setSocketData(res)
                    }

                });
                stompClientRef.current.subscribe('/topic/portal-changes', function (message) {
                    const events = JSON.parse(message.body);
                    setPortalChanges((prev) => {
                        const next = {...prev};
                        events.forEach((e) => {
                            const key = `${e.ageGroupId}_${e.disciplineId}_${e.disciplineStageId}`;
                            next[key] = {
                                sendPortal: e.sendPortal,
                                lastChangePortal: e.lastChangePortal,
                                hasNewChange: true,
                            };
                        });
                        return next;
                    });
                });
            }, (error) => {
                console.error('Ошибка подключения STOMP:', error);
                if (!toast.isActive("no-connection") && !toast.isActive("try-toast")) {
                    if (store.global.isShowSocketTurn) {
                        toast.error('Не удалось подключиться к серверу', {
                            toastId: 'no-connection',
                            autoClose: 2000
                        });
                    }
                }
                attemptReconnect();
            });
        };

        const attemptReconnect = () => {
            // Проверяем, активна ли вкладка
            if (document.visibilityState === 'hidden') {
                console.log('Вкладка неактивна, переподключение отложено');
                return;
            }

            reconnectTimeoutRef.current = setTimeout(() => {
                if (!toast.isActive("try-toast") && !toast.isActive("no-connection")) {
                    if (store.global.isShowSocketTurn) {
                        toast.dismiss();
                        toast.info('Попытка переподключения к серверу...', {
                            toastId: "try-toast",
                            autoClose: 2000,
                        });
                    }
                }
                connect();
            }, 2000);
        };

        // Обработчик изменения видимости вкладки
        const handleVisibilityChange = () => {
            if (document.visibilityState === 'visible') {
                // Вкладка стала активной, пробуем подключиться, если соединение разорвано
                if (!socketRef.current || socketRef.current.readyState !== WebSocket.OPEN) {
                    console.log('Вкладка активна, пробуем восстановить соединение');
                    connect();
                }
            } else {
                // Вкладка неактивна, очищаем таймер переподключения
                if (reconnectTimeoutRef.current) {
                    clearTimeout(reconnectTimeoutRef.current);
                    reconnectTimeoutRef.current = null;
                }
            }
        };

        // Добавляем слушатель события изменения видимости
        document.addEventListener('visibilitychange', handleVisibilityChange);

        connect();

        return () => {
            if (stompClientRef.current) {
                stompClientRef.current.disconnect();
            }
            if (socketRef.current) {
                socketRef.current.close();
            }
            if (reconnectTimeoutRef.current) {
                clearTimeout(reconnectTimeoutRef.current);
            }
        };

    }, [])

    useEffect(() => {
        const updateData = async () => {
            if (ids?.id_group === null || ids?.id_disciplin === null || ids?.discipline_stage_id === null) return
            await store.judging.getAllCommand(ids?.id_group, ids?.id_disciplin, ids?.discipline_stage_id)
            setCommands(store.judging.commands)

            await store.judging.statusJudging()
            setStatusInfo(JSON.parse(JSON.stringify(store.judging.status)))
        }

        if (socketData?.method === 'switch') {
            updateData()
        }
    }, [socketData])

    const closeOpenMenus = (e) => {
        if (catMenu.current && showMenu && !catMenu.current.contains(e.target)) {
            setShowMenu(false)
        }
    }

    useEffect(() => {
        if (!scoreCommand?.timekeeper_scores?.length) return;

        setTimers(prev => {
            const isAnyRunning = Object.values(prev).some(coach =>
                coach.isEntryRunning || coach.isDeckRunning || coach.isRoutineRunning
            );

            if (isAnyRunning) {
                console.log('Таймеры бегут — игнорируем обновление лимитов с сервера');
                return prev;
            }

            const next = {...prev};

            scoreCommand.timekeeper_scores.forEach(score => {
                const key = score.coach_type_number.toString();
                if (next[key]) {
                    next[key] = {
                        ...next[key],
                        entry: score.entry,
                        deck: score.deck,
                        routine: score.routine,
                        isEntryOut: score.entry_is_limit,
                        isDeckOut: score.deck_is_limit,
                        isRoutineOut: score.routine_is_limit,
                        wasEntryStarted: score.was_entry_started,
                        wasDeckStarted: score.was_deck_started,
                        wasRoutineStarted: score.was_routine_started,
                    };
                }
            });

            return next;
        });
    }, [scoreCommand]);

    // useEffect(() => {
    //     if (scoreCommand?.timekeeper_scores) {
    //         const updatedTimers = getDefaultTimers();
    //         scoreCommand.timekeeper_scores.forEach((score) => {
    //             const coachNumber = score.coach_type_number.toString();
    //             if (updatedTimers[coachNumber]) {
    //                 updatedTimers[coachNumber] = {
    //                     ...updatedTimers[coachNumber],
    //                     entry: score.entry,
    //                     deck: score.deck,
    //                     routine: score.routine,
    //                     isEntryOut: score.entry_is_limit,
    //                     isDeckOut: score.deck_is_limit,
    //                     isRoutineOut: score.routine_is_limit,
    //                     isEntryRunning: false,
    //                     isDeckRunning: false,
    //                     isRoutineRunning: false,
    //                     wasEntryStarted: score.was_entry_started,
    //                     wasDeckStarted: score.was_deck_started,
    //                     wasRoutineStarted: score.was_routine_started
    //                 };
    //             }
    //         });
    //
    //         setTimers(updatedTimers);
    //     }
    // }, [scoreCommand, setTimers]);
    document.addEventListener('mousedown', closeOpenMenus)

    return (
        <div className={s.judging_wrapper}>
            <AlertDialogCustomButton
                open={openDialogCustom} setOpen={setOpenDialogCustom} handlerRedButton={resetJudgeSession}
                handlerBlueButton={choiceJudge}
                redButton={'Сброс сессии устройства'}
                blueButton={'Перейти к выбору судьи'}
                couchTypeId={coachTypeId}
                couchTypeNumber={coachTypeNumber}
            />
            {<div className={s.select} onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                setShowMenu(!showMenu)
            }} ref={catMenu}>
                <div className={s.select_line}/>
                <div className={s.select_line}/>
                <div className={s.select_line}/>

                {showMenu && <div className={s.select_menu}>
                    {!isReferee && headers.map((el) => <div key={el.id} onClick={() => setHeaderSelect(el.id)}
                                                            className={classNames(s.select_menu_item, el.id === headerSelect && s.selected_item)}>{el.title}</div>)}
                    <div className={classNames(s.select_menu_item,)} style={{
                        color: '#e16565'
                    }} onClick={() => {
                        localStorage.removeItem('token');
                        localStorage.removeItem("role")
                        window.location.reload();
                    }}>
                        Выход
                    </div>
                </div>}

            </div>}

            {(socketData !== null && socketData?.method === 'hand') && <Dialog
                open={socketData !== null}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {socketData.msg}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setSocketData(null)}>OK</Button>
                </DialogActions>
            </Dialog>}
            <div className={s.serverVersion}
                 style={{marginRight: '90px'}}>
                {store.global.isShowReplication && <ReplicationDot/>}
            </div>
            <div className={s.serverVersion} style={{background: versionColor}}>{version}</div>
            {headerSelect === 1 && <Header isReferee={isReferee} movingStatusNextOrPrev={movingStatusNextOrPrev}
                                           startJudging={startJudging}
                                           stopJudging={stopJudging} statusInfo={statusInfo} setSelect={setSelect}
                                           selectedCommand={selectedCommand}
                                           setCommands={setCommands}
                                           age_group_id={ids.id_disciplin}
                                           nameCommand={commands?.find((f) => f?.competition_application_discipline_id === selectedCommand)?.competition_application_name}
                                           select={select}
                                           setStatusInfo={setStatusInfo}
                                           ageGroupDisciplines={ageGroupDisciplines}
                                           setAgeGroupDisciplines={setAgeGroupDisciplines}
                                           getAllCommand={getAllCommand} socketData={socketData}
                                           setShouldScroll={setShouldScroll}
                                           portalChanges={portalChanges}
                                           onPortalSent={(id, sendPortal) => {
                                               setPortalChanges((prev) => ({
                                                   ...prev,
                                                   [id]: {...prev[id], sendPortal, hasNewChange: false},
                                               }));
                                           }}
            />}
            {(ids.id_disciplin !== 1) ? <>
                {headerSelect === 1 && <>
                    <Commands isReferee={isReferee} doubleStartJudging={doubleStartJudging} statusInfo={statusInfo}
                              getScoreCommand={getScoreCommand}
                              setSelectedCommand={setSelectedCommand}
                              selectedCommand={selectedCommand} select={select} socketData={socketData}
                              commands={commands} setShowMoreCommand={setShowMoreCommand}
                              showMoreCommand={showMoreCommand}
                              setCommands={setCommands}
                              shouldScroll={shouldScroll}
                              setShouldScroll={setShouldScroll}
                    />
                    {isTimerVisible &&
                        <TimerReceiver timers={timers}
                                       setTimers={setTimers}
                                       judgeStatus={judgleStatus}
                                       selectedCommand={selectedCommand}
                                       setOpenDialogCustom={setOpenDialogCustom}
                                       setCoachTypeId={setCoachTypeId}
                                       setCoachTypeNumber={setCoachTypeNumber}/>}
                    <Table setClearScore={setClearScore}
                           isReferee={isReferee}
                           judgleStatus={judgleStatus}
                           setNewScore={setNewScore}
                           setNewListScore={setNewListScore}
                           saveButton={saveButton}
                           selectedCommandObject={selectedCommandObject}
                           setJudgleStatus={setJudgleStatus}
                           scoreCommand={scoreCommand}
                           selectedCommand={selectedCommand}
                           showMoreCommand={showMoreCommand}
                           setOpenDialogCustom={setOpenDialogCustom}
                           setCoachTypeId={setCoachTypeId}
                           setCoachTypeNumber={setCoachTypeNumber}
                           isShowTvSwitcher={store.global.isShowTvSwitcher}
                           socketData={socketData}
                    />
                </>}
            </> : (headerSelect === 1 &&
                <FigureBox
                    socketData={socketData}
                    judgleStatus={judgleStatus}
                    id_disciplin={ids.id_disciplin}
                    id_group={ids.id_group}
                    setOpenDialogCustom={setOpenDialogCustom}
                    setCoachTypeId={setCoachTypeId}
                    setCoachTypeNumber={setCoachTypeNumber}
                />
            )}

            {headerSelect === 2 && <SettingsDistiplines/>}
            {headerSelect === 3 && <SettingsSorev/>}
            {headerSelect === 4 && <Report/>}
            {(headerSelect === 5 && isReferee === false) && <JudgeSettings/>}

        </div>
    );
});

export default Judging;
